module.exports = __webpack_public_path__ + "static/media/1.5f3f9e05.png";